import '../../styles/CustomRender.scss';
import React from 'react';
import DiagramIDE from '../../ide/DiagramIDE';

/**
 * A JavaScript class to do the type-ambiguous dirtywork for TypeScript Renderers.
 * If things go wrong it's all in this class.
 */
export class RenderHelper {
    /**
     * Makes the React elements for the input ports.
     * @param inputs the input ports
     * @param inputNames the list of names of input ports
     * @returns {ReactNode[]}
     */
    static makeInputDivs(inputs, inputNames) {
        let inpDivs = [];
        if (inputs) {
            for (let ix = 0; ix < inputs.length; ix++) {
                inpDivs.push((
                    <div className='InputPortDiv' key={inputs[ix].key + 'div'}>
                        {React.cloneElement(inputs[ix], { className: "port" })}
                        {inputNames && <label>{inputNames[ix]}</label>}
                    </div>
                ));
            }
        }

        return inpDivs;
    }

    /**
     * Makes the React elements for the output ports.
     * @param outputs the output ports
     * @param outputNames the list of names of output ports
     * @returns {ReactNode[]}
     */
    static makeOutputDivs(outputs, outputNames) {
        let outDivs = [];
        if (outputs) {
            for (let ix = 0; ix < outputs.length; ix++) {
                outDivs.push((
                    <div className='OutputPortDiv' key={outputs[ix].key + 'div'}>
                        {outputNames && <label>{outputNames[ix]}</label>}
                        {React.cloneElement(outputs[ix], { className: "port" })}

                    </div>
                ));
            }
        }

        return outDivs;
    }

    static deleteNode(parentSchema, id) {
        DiagramIDE.getIDE()
            .schemaMethods
            .get(parentSchema)
            .deleteNodeFromSchema(id);
    }
}